export class UserProfile
{
    displayName: string
    loginName: string
    isAdmin: any
}
